import { Divider as MUIDivider, styled } from '@mui/material';
import { ReactNode } from 'react';

const StyledDivider = styled(MUIDivider)<{
  textAlign?: 'left' | 'center' | 'right';
  noMargin?: boolean;
}>(({ textAlign, noMargin }) => ({
  color: 'var(--text-text-secondary-color)',
  margin: noMargin ? 0 : '16px 0',
  fontSize: 13,
  width: '100%',
  span: {
    paddingLeft: textAlign === 'left' ? 0 : undefined,
  },
  '&::before': {
    content: textAlign === 'left' ? 'none' : undefined,
  },
  '&::after': {
    borderTopColor: 'var(--stroke-stroke-secondary-color)',
  },
}));

export type DividerProps = {
  text?: string | ReactNode;
  textAlign?: 'left' | 'center' | 'right';
  noMargin?: boolean;
  className?: string;
};

export const Divider = ({
  text,
  noMargin,
  textAlign,
  className,
}: DividerProps) => {
  return (
    <StyledDivider
      textAlign={textAlign}
      noMargin={noMargin}
      className={className}
    >
      {text}
    </StyledDivider>
  );
};
